<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NT4tZP/tc-custom/9781398493902.jpg?1705056298567" alt="This image is the cover for the book The Devil’s Ferryman"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Devil’s Ferryman
      </h1>
      <p class="bookDescription body article font2">
        <p>Detective Inspector Jimmy Nicholls is an outstanding young police officer in the Met who is leading the investigation into the brutal murder of four drug-addicted lowlifes, killed on the doorstep of one of the most notorious crime bosses in London. As he begins his investigation, he finds himself being warned off investigating the crime boss by the Met Commissioner, who also happens to be the father of his girlfriend, and a man he has known most of his life. With no leads and little in the way of forensic evidence, the case doesn’t seem to be going anywhere. That is until the killer gets in touch with Nicholls in a completely unexpected way and warns him not to speak to anyone else, or his life will be in danger. Nicholls initially has no choice but to comply with the killer’s demands but as more details are revealed, Nicholls learns some grisly details about his own family’s past that leads him to question who the real criminals are. Nicholls and the killer begin to form an uneasy alliance as they work together to uncover some shocking truths about the relationship between organised crime and corruption in London. As the machinations of power are slowly revealed, Nicholls learns of a nefarious plot by the criminals to take control of the government. It is down to him and the killer to stop it.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Simpson
      </h2>
      
      <p class="authorDescription body article">Michael Simpson is married to Ellen and lives in Cambridgeshire with his children, Evelyn, Rory and Max. He only started writing during lockdown and The Devil’s Ferryman is his debut novel. Michael has been a secondary school teacher for over sixteen years and he teaches physical education, history and sociology. In his spare time, Michael enjoys keeping fit, playing football and spending time with his family.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?23bf8f65